import { injectable } from "inversify";

import { IApiService } from "./shared/ApiService";
import { AuthenticationModelOutput } from "../models/LoginModels";
import * as Api from "../constants/ApiUrlConstants"
import container from "../wires/Bootstrapper";
import SERVICE_IDENTIFIER from "../wires/Identifiers";

export interface IAccountService {
    Login(username: string, password: string): Promise<AuthenticationModelOutput>
}

@injectable()
export class AccountService implements IAccountService {

    apiService: IApiService

    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE);
    }

    async Login(username: string, password: string): Promise<AuthenticationModelOutput> {
        return await this.apiService.postAsync<AuthenticationModelOutput>(Api.AccountLogin, { UserName: username, Password: password });
    }
}